module.exports = __webpack_public_path__ + "static/media/1000254035.bc9d741a.jpg";